import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-5c5b4f9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "farming_people" }
const _hoisted_2 = { id: "farming_content" }
const _hoisted_3 = {
  id: "farming_people_title",
  "data-aos": "fade-down",
  "data-aos-duration": "800"
}
const _hoisted_4 = { id: "people_list" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { id: "people_box" }
const _hoisted_8 = { id: "people_name" }
const _hoisted_9 = { id: "people_des_box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "people_des_icon",
  src: _imports_0
}, null, -1))
const _hoisted_11 = { id: "people_des_conent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($data.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "people",
            key: item.name,
            style: _normalizeStyle({ 'flex-direction': index % 2 == 0 ? 'row' : 'row-reverse', 'background': index % 2 == 0 ? '#f6f6f6' : '#fffff' }),
            "data-aos": "fade-up",
            "data-aos-duration": "800",
            "data-aos-delay": index * 150
          }, [
            _createElementVNode("img", {
              id: "people_img",
              src: require(`@/assets/framing/${item.img}`)
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(`${item.name} :`), 1),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(item.des), 1)
              ])
            ])
          ], 12, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}